import { Users, Compass, Filter } from "lucide-react";

export default function FeedToggle({ value, onChange }) {
  return (
    <div data-testid="feed-toggle" className="border hairline bg-white rounded-2xl p-3 mb-5 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 flex-1">
        <button
          data-testid="toggle-vinculos"
          onClick={() => onChange("vinculos")}
          className={`flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-4 sm:px-5 py-2.5 rounded-full text-sm transition-all duration-300 ${
            value === "vinculos"
              ? "bg-ink text-cream shadow-sm"
              : "bg-transparent text-ink/70 hover:bg-cream-deep/50"
          }`}
        >
          <Users className="w-4 h-4" strokeWidth={1.8} />
          <span>Vínculos</span>
          {value === "vinculos" && (
            <span className="ml-1 text-[10px] font-mono uppercase tracking-[0.2em] text-coral">activo</span>
          )}
        </button>
        <button
          data-testid="toggle-horizonte"
          onClick={() => onChange("horizonte")}
          className={`flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-4 sm:px-5 py-2.5 rounded-full text-sm transition-all duration-300 ${
            value === "horizonte"
              ? "bg-coral text-cream shadow-sm"
              : "bg-transparent text-ink/70 hover:bg-cream-deep/50"
          }`}
        >
          <Compass className="w-4 h-4" strokeWidth={1.8} />
          <span>Horizonte</span>
          {value === "horizonte" && (
            <span className="ml-1 text-[10px] font-mono uppercase tracking-[0.2em] text-cream/80">activo</span>
          )}
        </button>
      </div>
      <button
        data-testid="feed-filter"
        className="hidden md:inline-flex items-center gap-2 text-xs text-ink-mid hover:text-ink transition border hairline rounded-full px-3 py-2"
      >
        <Filter className="w-3.5 h-3.5" />
        Filtros
      </button>
    </div>
  );
}
